/* eslint no-debugger: "off" */

export default function slider(root, config = {}) {

  const mergedConfig = {
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    variableWidth: true,
    variableHeight: true,
    dots: true,
    adaptiveHeight: true,
    appendDots: root.find('.controls .dots'),
    prevArrow: root.find('.controls .prev'),
    nextArrow: root.find('.controls .next'),
    ...config,
  }

  const $heroPause = root.find('.controls [data-action="pause"]')
  const $heroPauseIcon = $heroPause.find('.playing')
  const $heroPlayIcon = $heroPause.find('.pausing')
  const $heroDots = root.find('.controls .dots')
  const $heroEl = root.find('.slider')

  let isPlaying = mergedConfig.autoplay

  if (!isPlaying) {
    togglePauseButton()
  }

  $heroPause.on('click', () => {
    $heroEl.slick(isPlaying && 'slickPause' || 'slickPlay')
    isPlaying = !isPlaying

    togglePauseButton()
  })

  $heroEl.on('init reInit afterChange', function(event, slick, current) {
    const i = (current ? current : 0) +1
    if (slick.slideCount > 4) {
      $heroDots.text(`${i} - ${slick.slideCount}`)
    }
  })

  $heroEl.slick(mergedConfig)

  function togglePauseButton() {
    if (isPlaying) {
      $heroPauseIcon.show()
      $heroPlayIcon.hide()
    } else {
      $heroPlayIcon.show()
      $heroPauseIcon.hide()
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/autoload/slider.js